(function () {
  const initAnimation = (section) => {
    if (
      !section ||
      !section.classList.contains("media-banner-section") ||
      !section.querySelector(".animate-on-scroll")
    )
      return;

    const text = section.querySelector(".media-banner__heading");

    if (!text) return;

    ScrollTrigger.create({
      trigger: text,
      start: "50% 95%",
      end: "bottom top",
      onEnter: () => text.classList.add("animated"),
    });
  };

  initAnimation(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initAnimation(event.target);
  });
})();

(() => {
  // Initialize bubbles animation for a specific section
  function initBubblesAnimation(section) {
    if (!section) return;

    // Find canvas within this specific section
    const canvas = section.querySelector('[data-bubbles-canvas]');
    if (!canvas) return;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const host = canvas.closest("[data-bubbles-host]") || canvas.parentElement;
    if (!host) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    let w = 0, h = 0, dpr = 1;
    const rand = (a, b) => a + Math.random() * (b - a);

    // =========================
    // TWEAKS
    // =========================
    const DENSITY = 5;      // ⬆️ increase for more bubbles (try 1.2–2.2)
    const MAX_BUBBLES = 900;  // safety cap
    const MIN_BUBBLES = 180;

    // mostly-small size distribution (far-away bubbles)
    function pickRadius() {
      const t = Math.random();

      // Flood it with tiny, far-away bubbles
      if (t < 0.90) return rand(1.0, 4.0);   // 90% tiny

      // A few medium
      if (t < 0.985) return rand(4.0, 8.0);  // ~8.5% medium

      // Rare foreground accents (same cap as before)
      return rand(8.0, 11.0);               // ~1.5% large
    }

    function resize() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = host.clientWidth;
      h = host.clientHeight;

      canvas.width  = Math.floor(w * dpr);
      canvas.height = Math.floor(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function bubbleCount() {
      const area = w * h;

      // old: area/12000 (120–420)
      // new: denser + tunable
      const base = area / 9000; // ⬆️ smaller divisor = more bubbles
      const n = Math.floor(base * DENSITY);

      return Math.max(MIN_BUBBLES, Math.min(MAX_BUBBLES, n));
    }

    let bubbles = [];

    function makeBubble(yOverride) {
      const r = pickRadius();

      // tiny bubbles should feel "further away"
      const far = r < 4.5 ? 1 : 0;

      return {
        ox: rand(0.28, 0.42),   // highlight direction: top-right
        oy: -rand(0.28, 0.42),

        x: rand(0, w),
        y: (typeof yOverride === "number") ? yOverride : rand(0, h),
        r,

        // smaller bubbles rise a bit faster (nice fizzy feel)
        vy: rand(0.10, 0.45) * (12 / Math.max(r, 2)),
        vx: rand(-0.12, 0.12),

        wobble: rand(0.8, 2.2),
        phase: rand(0, Math.PI * 2),

        // reduce opacity for far bubbles
        alpha: far ? rand(0.08, 0.22) : rand(0.14, 0.50)
      };
    }

    function init() {
      resize();
      bubbles = Array.from({ length: bubbleCount() }, () => makeBubble());
    }

    function drawBubble(b) {
      const gx = b.x + b.ox * b.r;
      const gy = b.y + b.oy * b.r;

      const g = ctx.createRadialGradient(gx, gy, b.r * 0.15, gx, gy, b.r);
      g.addColorStop(0.00, `rgba(30, 15, 50, 0)`);
      g.addColorStop(0.55, `rgba(30, 15, 50, ${0.10 * b.alpha})`);
      g.addColorStop(0.85, `rgba(30, 15, 50, ${0.26 * b.alpha})`);
      g.addColorStop(1.00, `rgba(30, 15, 50, ${0.45 * b.alpha})`);

      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(b.x, b.y, b.r, 0, Math.PI * 2);
      ctx.fill();

      // subtle rim stroke – tone it down for tiny bubbles
      const strokeMult = b.r < 4.5 ? 0.18 : 0.35;
      ctx.lineWidth = Math.max(0.6, b.r * 0.08);
      ctx.strokeStyle = `rgba(20, 10, 40, ${strokeMult * b.alpha})`;
      ctx.stroke();
    }

    let last = performance.now();
    let animationFrameId = null;

    function tick(now) {
      const dt = Math.min(40, now - last);
      last = now;

      ctx.clearRect(0, 0, w, h);

      for (const b of bubbles) {
        b.phase += 0.002 * dt * b.wobble;
        b.x += b.vx * dt + Math.sin(b.phase) * 0.08 * dt;
        b.y -= b.vy * dt;

        if (b.y < -b.r * 2) Object.assign(b, makeBubble(h + b.r * 2));
        if (b.x < -20) b.x = w + 20;
        if (b.x > w + 20) b.x = -20;

        drawBubble(b);
      }

      animationFrameId = requestAnimationFrame(tick);
    }

    init();

    const ro = new ResizeObserver(() => {
      resize();
      const target = bubbleCount();
      if (bubbles.length < target) while (bubbles.length < target) bubbles.push(makeBubble());
      else bubbles.length = target;
    });
    ro.observe(host);

    animationFrameId = requestAnimationFrame(tick);

    // Store cleanup function on the canvas element
    canvas._bubblesCleanup = () => {
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
      ro.disconnect();
    };
  }

  // Initialize all existing sections
  function initAllSections() {
    const sections = document.querySelectorAll('.media-banner-section');
    sections.forEach(section => {
      // Only initialize if not already initialized
      const canvas = section.querySelector('[data-bubbles-canvas]');
      if (canvas && !canvas._bubblesInitialized) {
        initBubblesAnimation(section);
        canvas._bubblesInitialized = true;
      }
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  // Handle Shopify section load/reload events
  document.addEventListener("shopify:section:load", function (event) {
    const section = event.target;
    if (section && section.classList.contains("media-banner-section")) {
      initBubblesAnimation(section);
    }
  });

  // Handle section unload to clean up
  document.addEventListener("shopify:section:unload", function (event) {
    const section = event.target;
    if (section) {
      const canvas = section.querySelector('[data-bubbles-canvas]');
      if (canvas && canvas._bubblesCleanup) {
        canvas._bubblesCleanup();
      }
    }
  });
})();
